<template>
  <div>
     <h3 style="background:#007bff;; padding: 10px; line-height: 42px; text-align: center; color: #fff;">Gallery</h3>
     <div class="row">
                    <div class="col-12">
                      <div class="row portfolio-grid">
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12" v-for="image in this.galleries">
                          <figure style="border-radius: 0.25rem;min-height: 195px;max-height:195px ;">
                            <img style="height:195px;" :src="'/uploads/'+image.filename" alt="image">
                            <figcaption v-if="this.delete">
                              <div class="close" @click="deletefile(image.id)">
                                <i class="fa fa-times closeicon" aria-hidden="true"></i>
                               </div>
                               <div class="caption" @click="changecaption(image)"
                               style="position: absolute;bottom: 0px;left: 0;background: rgb(102, 102, 102);display: block;width: 100%;"><a style="display:block;font-size: 14px;">{{image.caption}}&nbsp;&nbsp;<i class="fa fa-pencil" ></i></a></div>

                            </figcaption>           
                          </figure>
                        </div>
                       
                      </div>
                    </div>
        </div>
	     <transition name="modal">
		     <div v-if="showModal" class="vmodal">
		      <div class="modal-content">
		        <span @click="closeModal" class="close">&times;</span>
		        <p>Are you sure you want to delete it?</p>
		         <div class="buttons">
		            <div class="right">
		              <button @click="deleteItem" type="button" class="btn btn-danger btn-fw">Delete</button>&nbsp;&nbsp;
		              <button @click="closeModal" type="button" class="btn btn-info btn-fw">Cancel</button>
		            </div>
		          </div>
		      </div>
		    </div>
		 </transition>
     <transition name="modal">
         <div v-if="showModal2" class="vmodal">
          <div class="modal-content">
            <span @click="closeModal2" class="close">&times;</span>
            <p>Change Image Caption</p>
            <input type="text" class="form-control" v-model="caption" placeholder="Image Caption">
            <br>
             <div class="buttons">
                <div class="right">
                  <button @click="updatecaption" type="button" class="btn btn-danger btn-fw">update</button>&nbsp;&nbsp;
                  <button @click="closeModal2" type="button" class="btn btn-info btn-fw">Cancel</button>
                </div>
              </div>
          </div>
        </div>
     </transition>
    </div>
</template>
<script>
import $ from "jquery";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
 export default{
  props:['delete'],
  data(){
    return{
     galleries:[],
     showModal: false,
     deleteid:0,
     showModal2: false,
     caption:''
    }
  },
  computed:{
    url(){
      return this.$store.state.url;
    }
  },
  mounted(){
    this.getallimages();
  },
  methods:{
    getallimages(){
       axios.get(this.url+'getallimages').then(response=>{

         this.galleries=response.data;
         console.log(this.galleries);

       }) 
    },
    deletefile(imageid){
      this.deleteid=imageid;
      this.showModal = true;

    },
    changecaption(image){
      this.deleteid=image.id;
      this.showModal2 = true;
      this.caption=image.caption;
    },
    closeModal() {
      this.showModal = false;
    },    
    closeModal2() {
      this.showModal2 = false;
    },
    deleteItem() {
      this.closeModal();
      axios.post(this.url+'deleteimage',{
        id:this.deleteid,
      }).then(response=>{
        toast.success("Federation deleted successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });

        this.getallimages();

      })
    },
    updatecaption(){
      axios.post(this.url+'addcaption',{
        id:this.deleteid,
        caption:this.caption
      }).then(response=>{
        toast.success("Image Caption updated successfully", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.getallimages();
        this.closeModal2();

      }) 
    }
  },
  watch:{

       show2(newVal) {
         this.$nextTick(() => {
          if (newVal) {
          document.querySelector('.modal-container2').style.transform = 'translateY(0)';
           } else {
          document.querySelector('.modal-container2').style.transform = 'translateY(-100%)';
          }
         });
        },

    }

 }
</script>
<style>
    .close{
    position: relative;
    top: -30px;
    right: -30px;
    background: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    }
    .closeicon {
        top: 5px;
        position: absolute;
        left: 7px;
        color: red;
    }
</style>
<style scoped>
 .productlist,.productlist2,.productlist3
  {
    position: absolute;
    background: #333;
    color: white;
    width: 100%;
    z-index: 999999;
  }
  .productlist ul,.productlist2 ul,.productlist3 ul{
    list-style: none;
    background: rgb(0, 123, 255);
  }
  .productlist ul li,.productlist2 ul li,.productlist3 ul li{
    border-bottom: 1px solid white;
    padding:5px;
    cursor: pointer;
  }

  .pre-loader {
  padding: 10px;
  background-color: #f1f1f1;
  /* Add more styles as needed */
  }
  .table-responsive{
    overflow-x: hidden;
  }
  </style>
<style>
 form.fed_search {
    background: #3a3f51;
    display: block;
    width: 100%;
    float: left;
    padding: 15px;
    color: #fff;
    display: flex;
}
.fed_search_btn {
    background: #007bff;
    position: relative;
    top: 24px;
    padding: 5px 5px;
    line-height: 30px;
    border: 0px;
    width: 100%;
    color: white;
    font-size: 0.875rem;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  min-width: 160px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown-button {
  background-color: rgb(0, 123, 255);
  color: white;
  padding: 10px;
  font-size: 16px;
  border: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}
</style>
<style scoped>
.vmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  width:50%;
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 20px;
  cursor: pointer;
}

.button {
  margin-top: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.left {
  flex: 1;
}

.right {
  flex: 1;
  text-align: right;
}

.modal-enter-active, .modal-leave-active {
  transition: transform .5s ease-in, opacity .5s ease-out;
  transform: translateY(-50%);
  opacity: 1;
}
.modal-enter, .modal-leave-to /* .modal-leave-active in <2.1.8 */ {
  transform: translateY(-50%);
  opacity: 0 opacity .5s ease-out;
}

</style>
<style>
  .modal-mask2{
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  }
  .modal-wrapper2{
    display: table-cell;
    vertical-align: middle;
  } 
  .modal-container2{
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background: #3a3f51;
  color: white;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(-100%);
  transition: transform .3s ease-out;
}
.modal-header {
    padding: 5px!important;
    border-bottom: 1px solid #e5e5e5;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translate3d(0, -100%, 0);
  opacity: 0;
}

.wrappermodel{
  display: flex;

}

.lefside{
  width:48%;
  float:left;
  padding-right:10px;
}

.rightside{
   width:48%;
  float:left;
}

.modal-default-button{
  background: #007bff;
  border: 1px solid #007bff;
  color: white;
}


</style>